import React from 'react'
import { registerFeature } from '@core/feature-loading/registerFeature';
import { createFeatureLinks } from '@core/feature-loading/createFeatureLinks';

const onBoardingFeature = registerFeature('onboarding')

export const introduction = onBoardingFeature({ path: 'ok', loader: () => import('./Introduction') })

export const OnBoardingFeatureLinks = createFeatureLinks({
  default: introduction
})

export const OnBoarding = () => (
  introduction.registedFeature
)


// WEBPACK FOOTER //
// ./sampleProject/src/Features/OnBoarding/index.tsx